import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
// Component
import Card from '../../layout/sui/card/Card';


const propTypes = {
  roundTable: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
};

const RoundTable = (props) => {
  const roundTable = props.roundTable;
  const { title, vertical, day, start, end, room } = roundTable;

  const calcTime = (time) => {
    return new Date(`${day}, ${time}`);
  };

  const date = new Date(day);
  const starting = calcTime(start);
  const ending = calcTime(end);

  const meta = (
    <FormattedMessage
      id="roundTableDateTime"
      description="Panel date and time"
      defaultMessage="To be confirmed"
      values={{
        icon: <i className="calendar icon" />,
        date,
        starting,
        ending,
      }}
    />
  );

  const description = (
    <FormattedMessage
      id="roundTableRoom"
      description="Panel room"
      defaultMessage="{icon} Room {room}"
      values={{
        icon: <i className="unmute icon" />,
        room: <b style={{ textTransform: 'uppercase' }}>{room}</b>,
      }}
    />
  );

  const hasVertical = vertical && <div className="ui top attached center aligned blue label">{vertical}</div>;

  const contents = [
    {
      header: <span><br />{title}</span>,
      meta: hasVertical,
    },
  ];

  const extraContent = {
    meta,
    description,
  };

  let url;

  switch (props.locale) {
    case 'pt':
      url = '/pt/paineis/';
      break;
    case 'es':
      url = '/es/paneles/';
      break;
    default:
      url = '/en/round-tables/';
  }

  const link = `${url}${roundTable.id}`;

  return (
    <Card
      link={link}
      contents={contents}
      extraContent={extraContent}
    />
  );
};

RoundTable.propTypes = propTypes;

export default RoundTable;



/** WEBPACK FOOTER **
 ** ./src/components/screens/roundTables/RoundTable.js
 **/